import { serverHttp as Request } from "./http";

class WorkflowAdminService {
  getTaskSources(params = {}) {
    return Request.get("sharkfoto/admin/effect-workflow/task-sources", { params });
  }

  getTaskSource(id) {
    return Request.get(`sharkfoto/admin/effect-workflow/task-sources/${id}`);
  }

  createTaskSource(payload) {
    return Request.post("sharkfoto/admin/effect-workflow/task-sources", payload);
  }

  updateTaskSource(id, payload) {
    return Request.put(`sharkfoto/admin/effect-workflow/task-sources/${id}`, payload);
  }

  deleteTaskSource(id) {
    return Request.delete(`sharkfoto/admin/effect-workflow/task-sources/${id}`);
  }

  getRunBatches() {
    return Request.get("sharkfoto/admin/effect-workflow/run-batches");
  }

  getRunBatch(id) {
    return Request.get(`sharkfoto/admin/effect-workflow/run-batches/${id}`);
  }

  createRunBatch(payload) {
    return Request.post("sharkfoto/admin/effect-workflow/run-batches", payload);
  }

  cancelRunBatch(id) {
    return Request.put(`sharkfoto/admin/effect-workflow/run-batches/${id}`, {
      action: "cancel",
    });
  }

  purgeRunBatch(id) {
    return Request.delete(`sharkfoto/admin/effect-workflow/run-batches/${id}`);
  }

  purgeRunBatches(batchIds) {
    return Request.patch("sharkfoto/admin/effect-workflow/run-batches", {
      action: "purge",
      batch_ids: batchIds,
    });
  }

  getRunTasks(params = {}) {
    return Request.get("sharkfoto/admin/effect-workflow/run-tasks", { params });
  }

  getRunTask(id) {
    return Request.get(`sharkfoto/admin/effect-workflow/run-tasks/${id}`);
  }

  cancelRunTask(id) {
    return Request.put(`sharkfoto/admin/effect-workflow/run-tasks/${id}`, {
      action: "cancel",
    });
  }

  getRunTaskLogs(id, params = {}) {
    return Request.get(`sharkfoto/admin/effect-workflow/run-tasks/${id}/logs`, {
      params,
    });
  }

  getSchemaSql() {
    return Request.get("sharkfoto/admin/effect-workflow/schema");
  }
}

export default new WorkflowAdminService();
